module.exports = __webpack_public_path__ + "img/minipro.6cef17b1.png";